module.exports = __webpack_public_path__ + "img/sy-tz.7becccb0.svg";